/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyVersionModel } from '../../models/client-survey-version-model';
import { CreateSurveyVersionRequest } from '../../models/create-survey-version-request';

export interface CreateSurveyVersion$Plain$Params {
  
    /**
     * properties of surveyversion to create
     */
    body?: CreateSurveyVersionRequest
}

export function createSurveyVersion$Plain(http: HttpClient, rootUrl: string, params?: CreateSurveyVersion$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyVersionModel>> {
  const rb = new RequestBuilder(rootUrl, createSurveyVersion$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyVersionModel>;
    })
  );
}

createSurveyVersion$Plain.PATH = '/api/SurveyVersion';
